<app-modal>
    <div class="modal-body" modal-body *ngIf="revisionInfo.length > 0; else noItems">
        <ng-container *ngFor="let tool of revisionInfo">
            <app-revision-info [revisionInfo]="tool"></app-revision-info>
        </ng-container>
    </div>

    <div class="modal-footer" modal-footer>
        <app-button type="simple"
                    (click)="onCancel()"
                    data-dismiss="modal">{{ "generic.buttons.close" | translate }}
        </app-button>
    </div>
</app-modal>

<ng-template #noItems>
    <div class="empty-message">
        {{ 'admin.tickets.create-modal.revisionInfo.empty-message' | translate }}
    </div>
</ng-template>
